import InitialLoader from "components/InitilalLoader";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import "../../Subscription/Subscription.scss";
import CommonCartingseries from "./CommonCartingSeries";
import { randomKey } from "../../../utils/utils";
import { useAllSeriesCarting } from "./hooks/useAllSeriesCarting";
import { useAddUpdateCartingSeries } from "./hooks/useAddUpdateCartingSeries";
import { useDeleteSeriesCarting } from "./hooks/useDeleteSeriesCarting";
import { useCartingOptions } from "./hooks/useCartingOptions";

function CartingPricing() {
  const [selectCatagory, setSelectCatagory] = useState("");
  const [add, setAdd] = useState(false);
  const [addNewSeries, setAddNewSeries] = useState(false);

  const { cartingTypes, isLoading } = useCartingOptions();
  const { data: cartingSeriesData, isLoading: isLoadingSeries } = useAllSeriesCarting(
    selectCatagory ? { category: selectCatagory } : null
  );
  const { mutate: saveOrUpdate } = useAddUpdateCartingSeries();
  const { mutate: remove } = useDeleteSeriesCarting();

  if (isLoading) return <InitialLoader />;

  const saveData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const editData = (data, callbacks) => saveOrUpdate(data, callbacks);
  const deleteData = (id, callbacks) => remove(id, callbacks);
  const showAddNew = !!selectCatagory;

  return (
    <>
      <Row style={{ marginBottom: "2%" }}>
        <Col md="3">
          <Form.Group>
            <Form.Label>Category</Form.Label>
            <Form.Control
              as="select"
              value={selectCatagory}
              onChange={(e) => setSelectCatagory(e.target.value)}
            >
              <option value="">Choose...</option>
              <option value="Carting">Carting</option>
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>

      {isLoadingSeries ? (
        <InitialLoader />
      ) : (
        <>
          {showAddNew && !add && (
            <Row style={{ marginBottom: "4%", float: "right" }}>
              <Col md="12">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setAdd(true);
                    setAddNewSeries(true);
                  }}
                >
                  Add New
                </button>
              </Col>
            </Row>
          )}

          {cartingSeriesData?.length > 0 && (
            <Row style={{ marginTop: "10%" }}>
              <Col md="3">
                <Form.Group style={{ textAlign: "center" }}>
                  <Form.Label>Carting Type</Form.Label>
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group style={{ textAlign: "center" }}>
                  <Form.Label>Size</Form.Label>
                </Form.Group>
              </Col>
              <Col md="3">
                <Form.Group style={{ textAlign: "center" }}>
                  <Form.Label>Price Per UOM</Form.Label>
                </Form.Group>
              </Col>
            </Row>
          )}

          {add && (
            <CommonCartingseries
              saveData={saveData}
              editData={true}
              setAddNewSeries={setAddNewSeries}
              addNewSeries={addNewSeries}
              category={selectCatagory}
              add={add}
              deleteData={deleteData}
              setAdd={setAdd}
              cartingTypes={cartingTypes}
            />
          )}

          {cartingSeriesData?.length > 0
            ? cartingSeriesData.map((data) => (
                <CommonCartingseries
                  key={data._id || randomKey}
                  setAddNewSeries={setAddNewSeries}
                  saveData={editData}
                  deleteData={deleteData}
                  addNewSeries={addNewSeries}
                  category={data.category}
                  pricePerUom={data.pricePerUOM}
                  pricingTypes={data.pricingType}
                  sizes={data.size}
                  _id={data._id}
                  cartingTypes={cartingTypes}
                  setAdd={setAdd}
                  priceData={data}
                />
              ))
            : showAddNew && (
                <h6 style={{ textAlign: "center", marginTop: "10%" }}>
                  No Data Found
                </h6>
              )}
        </>
      )}
    </>
  );
}

export default CartingPricing;
